<nav class="navbar navbar-expand-lg navbar-dark navbar-inverse navbar-fixed-top p-0" [ngClass]="isDashboardPage ? 'dashboardHeader' : 'standardHeader'">
    <div class="container-fluid py-3 align-items-center">
        <div class="d-flex w-100 align-items-center">

            <!-- Brand with Image -->
            <a class="navbar-brand d-flex align-items-center m-0 flex-shrink-0" href="javascript:void(0)" (click)="goToHome()"
                [routerLink]="['/home']">
                <span class="brand-logo-wrap">
                    <img class="logo" src="/assets/images/Deloitte_SEC.png" alt="Deloitte Logo">
                    @if (nonProdEnvironmentLabel) {
                    <span class="non-prod-env-label">{{ nonProdEnvironmentLabel }}</span>
                    }
                </span>
                <!-- <img src="assets/images/program-icons/cmp_assurance.png" alt="CMP Logo" height="40" class="me-2"> -->
                <span class="fw-semibold ms-2 text-nowrap" [style.font-size]="isProgramAdminDashboard ? '26px' : ''">Quality & Risk Sensing Program | Assurance nonattest engagements</span>
            </a>
            <div class="d-flex align-items-center flex-grow-1 justify-content-end">
                <div class="d-flex align-items-center w-100">
                    <div class="flex-grow-1 px-3">
                        @if(shouldShowSearchBox){
                        <div class="position-relative py-2 h-100" [style.width]="isQRSProgramFeatureEnabled ? '75%' : '85%'" style="margin: 0 auto;">
                            <input type="text" id="elNameSearch" class="input-search-new"
                                [placeholder]="'&#xF002; &nbsp; '+placeholderText" [(ngModel)]="searchbox"
                                (keyup)="onSearchKeyup($event)" />
                            @if(showCrossmark){
                            <span id="span-search-new" (click)="resetSearchBox()">x</span>
                            }
                            @if (showDropdown && searchbox && searchbox.length >= 3) {
                            <div style="max-height:500px;overflow:auto" class="elSearchResultTableDiv">
                                <table class="elSearchResultTable">
                                    <tbody id="search_result_el_dashboard">
                                        @for (name of elNameDetails | fuzzy:searchbox; track name; let idx = $index) {
                                        @if (isOPLD) {
                                        <tr>
                                            @let details = getDetails(name);
                                            <td class="elSearchResultCell" style="font-size:17px"
                                                [attr.id]="'header_search'+idx"
                                                [class.active]="idx === selectedResultIndex" tabindex="0"
                                                (keydown)="onResultKeydown($event, idx, name)"
                                                (click)="fillTextbox(name, undefined, 'click')">

                                                <span>
                                                    <strong>Engagement Leader: </strong>
                                                    <span
                                                        [innerHTML]="details?.EngagementLeader | highlight:searchbox"></span><br />
                                                    <strong>Client Name: </strong>
                                                    <span
                                                        [innerHTML]="details?.ClientName | highlight:searchbox"></span><br />
                                                    <strong>DAP Id: </strong>
                                                    <span
                                                        [innerHTML]="details?.DapId || '-' | highlight:searchbox"></span>
                                                    |
                                                    <strong>Solution Name: </strong>
                                                    <span
                                                        [innerHTML]="details?.SolutionName | highlight:searchbox"></span><br />
                                                    <strong>Opportunity Id: </strong>
                                                    <span
                                                        [innerHTML]="details?.OpportunityId | highlight:searchbox"></span><br />
                                                </span>
                                            </td>
                                        </tr>
                                        } @else {
                                        <tr>
                                            @let details = getDetails(name);
                                            <td class="elSearchResultCell" style="font-size:17px"
                                                [attr.id]="'header_search'+idx"
                                                [class.active]="idx === selectedResultIndex" tabindex="0"
                                                (keydown)="onResultKeydown($event, idx, name)"
                                                (click)="fillTextbox(details?.EngagementName || '', undefined, 'click')">

                                                <span>
                                                    <strong>Engagement Name: </strong>
                                                    <span
                                                        [innerHTML]="details?.EngagementName | highlight:searchbox"></span><br />
                                                    <strong>Client Name: </strong>
                                                    <span
                                                        [innerHTML]="details?.ClientName | highlight:searchbox"></span><br />
                                                    <strong>DAP ID: </strong>
                                                    <span [innerHTML]="details?.DapId | highlight:searchbox"></span> |
                                                    <strong>Opportunity ID: </strong>
                                                    <span [innerHTML]="details?.MercuryId | highlight:searchbox"></span>
                                                </span>
                                            </td>
                                        </tr>
                                        }
                                        }
                                        @if (IsNoData) {
                                        <tr>
                                            <td><strong>No Results Found</strong></td>
                                        </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                            }
                        </div>
                        }
                    </div>
                    <div class="d-flex align-items-center flex-shrink-0 ms-3">
                        <!-- @if (shouldShowRiskCategoriesButton) {
                        <button class="btn btn-primary btn-lg text-capitalize" (click)="openRiskCategories()">Risk
                            Categories</button>
                        } -->
                        <i class="deloitte-icon cog_pos mx-4" [ngbPopover]="popContent" popoverClass="in fs-5" container="body" placement="bottom"
                            [autoClose]="true" triggers="hover" [closeDelay]="500"></i>
                        @if(UserInitials){
                        <div [ngbPopover]="userPopup" popoverClass="in userProfilePopup" [autoClose]="true"
                            triggers="click" class="text-white" [disablePopover]="!isUserPopupAllowed">
                            @if(elImage){
                            <img [src]="elImage" alt="User Image" class="user-image" height="55" />
                            }
                            @else {
                            <span class="userInitials">{{UserInitials}}</span>
                            }
                            <span class="fa fa-carat-down px-2"></span>
                            <span class="p-3 fs-3">Hi, {{userFirstName}}</span>
                        </div>
                        }
                        <a class="logout-btn" href="javascript:void(0)" title="Logout" (click)="logout()">
                            <img src="/assets/images/Logout.png" alt="Logout">
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</nav>

<ng-template #popContent>
    <ul class="list-unstyled mb-0 fs-6">
        <li class="mb-2">
            <a class="text-decoration-none text-black"
                href="mailto:usassurancenonattestqualityandrisksensing@deloitte.com">
                <img src="assets/images/program-icons/email.png" class="mailicons bg-white" />
                Email</a>
        </li>
        @if(canShowAuditTrail){
        <li class="mb-2">
            <a class="text-decoration-none text-black" href="javascript:void(0)" (click)="openAuditTrail()">
                <img src="assets/images/program-icons/audit.png" class="mailicons" />
                Audit Trail</a>
        </li>
        }
        @if(!canShowAuditTrail && roleService.isAdmin() && isOPorELD){
        <li class="mb-2">
            <a class="text-decoration-none text-black" (click)="openAuditDetails()" style="cursor: pointer;">
                <img src="assets/images/program-icons/audit.png" class="mailicons" />
                Audit Details</a>
        </li>
        }
    </ul>
</ng-template>
<ng-template #userPopup>
    <div class="row">
        <div class="col-3">
            @if(elImage) {
            <img [src]="elImage" alt="User Image" class="user-image" height="85" />
            } @else {
            <span class="userInitials" #userTarget>{{UserInitials}}</span>
            }
        </div>
        <div class="col profileDetails">
            <p>Hi, {{userFirstName}}</p>
            <p><span class="fs-3 text-secondary">Role:</span> <span
                    class="fw-bolder">{{roleService.getRoleName()}}</span></p>
        </div>
    </div>

</ng-template>
